import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../auth/auth.service';

class LoginModel {
    email: string;
    password: string;
}

@Component({
    selector: 'error/error',
    template: require('./error.component.html')
})

export class ErrorComponent {
    
    constructor(
        private router: Router,
        private authenticationService: AuthService) { }

    logout() {
        this.authenticationService.logout();

        this.router.navigate(['/account/login']);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/error/error.component.ts